import { render, staticRenderFns } from "./Abteilungen.vue?vue&type=template&id=842d0142"
import script from "./Abteilungen.vue?vue&type=script&lang=js"
export * from "./Abteilungen.vue?vue&type=script&lang=js"
import style0 from "./Abteilungen.vue?vue&type=style&index=0&id=842d0142&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports